import { compressToBase64, decompressFromBase64 } from "lz-string";
import * as z from "zod/v4";
import { AdvancedFilterDataSchema } from "../../../views/views";
import { ApprovalDateFilterSchema } from "./approval-date-filter";
import { CompensationMethodFilterSchema } from "./compensation-method-filter";
import { CompensationMethodsFilterSchema } from "./compensation-methods-filter";
import { OrderCreatedDateFilterSchema } from "./order-created-date-filter";
import { OrderProcessedDateFilterSchema } from "./order-processed-date-filter";
import { ProductNameFilterSchema } from "./product-name-filter";
import { ProductProcessedDateFilterSchema } from "./product-processed-date-filter";
import { ProductStatusFilterSchema } from "./product-status-filter";
import { ProductTagsFilterSchema } from "./product-tags-filter";
import { ProductTypeFilterSchema } from "./product-type-filter";
import { ReportFilterType } from "./report-filter-type";
import { ReturnCreatedDateFilterSchema } from "./return-created-date-filter";
import { ReturnDeliveryDateFilterSchema } from "./return-delivery-date-filter";
import { ReturnProcessedDateFilterSchema } from "./return-processed-date-filter";
import { ReturnStatusFilterSchema } from "./return-status-filter";
import { ReturnTypeFilterSchema } from "./return-type-filter";
import { VariantNameFilterSchema } from "./variant-name-filter";

const ReportFilterSchema_ = z.union([
  ReturnTypeFilterSchema,
  OrderCreatedDateFilterSchema,
  // OrderDeliveryDateFilterSchema,
  ReturnCreatedDateFilterSchema,
  ReturnDeliveryDateFilterSchema,
  ApprovalDateFilterSchema,
  ReturnProcessedDateFilterSchema,
  // PurchasedRedoFilterSchema,
  ReturnStatusFilterSchema,
  CompensationMethodsFilterSchema,

  ProductProcessedDateFilterSchema,
  ProductStatusFilterSchema,
  CompensationMethodFilterSchema,
  ProductNameFilterSchema,
  VariantNameFilterSchema,

  OrderProcessedDateFilterSchema,
  ProductTypeFilterSchema,
  ProductTagsFilterSchema,

  AdvancedFilterDataSchema,
]);
export const ReportFilterSchema: z.ZodType<ReportFilter> = ReportFilterSchema_;
export type ReportFilter = {} & z.infer<typeof ReportFilterSchema_>;

export type KnownReportFilter = Exclude<
  ReportFilter,
  z.infer<typeof AdvancedFilterDataSchema>
>;

export function isKnownReportFilter(
  filter: ReportFilter,
): filter is KnownReportFilter {
  return (
    "type" in filter &&
    Object.values(ReportFilterType).includes(filter.type as ReportFilterType)
  );
}

export function reportFiltersToQueryString(filters: ReportFilter[]): string {
  const str = JSON.stringify(filters);
  const compressed = compressToBase64(str);
  return compressed;
}

/** @throws If the string does not represent a valid filters array */
export function queryStringToReportFilters(
  queryString: string,
): ReportFilter[] {
  const decompressed = decompressFromBase64(queryString);
  const obj = JSON.parse(decompressed);
  return ReportFilterSchema.array().parse(obj);
}

//'[{"type":"orderCreatedDate","query":"within","value":["2025-03-19T00:00:00.000Z","2025-03-20T00:00:00.000Z"]}]'
